import type { HTMLAttributes } from 'react'
import clsx from 'clsx'

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Adds hover effect (border highlight) */
  hoverable?: boolean
  /** Removes padding for custom layout */
  noPadding?: boolean
  /** Subtle glass/blur effect */
  glass?: boolean
}

export function Card({ hoverable = false, noPadding = false, glass = false, children, className, ...props }: CardProps) {
  return (
    <div
      className={clsx(
        'rounded-xl border border-slate-700/50 transition-colors duration-200',
        glass
          ? 'bg-slate-800/40 backdrop-blur-sm'
          : 'bg-slate-800/50',
        !noPadding && 'p-5',
        hoverable && 'hover:border-slate-600/60 hover:bg-slate-800/70 cursor-pointer',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

interface CardHeaderProps extends HTMLAttributes<HTMLDivElement> {}
export function CardHeader({ children, className, ...props }: CardHeaderProps) {
  return (
    <div className={clsx('flex items-center justify-between mb-4', className)} {...props}>
      {children}
    </div>
  )
}

interface CardTitleProps extends HTMLAttributes<HTMLHeadingElement> {}
export function CardTitle({ children, className, ...props }: CardTitleProps) {
  return (
    <h3 className={clsx('text-sm font-semibold text-slate-100', className)} {...props}>
      {children}
    </h3>
  )
}

interface CardContentProps extends HTMLAttributes<HTMLDivElement> {}
export function CardContent({ children, className, ...props }: CardContentProps) {
  return (
    <div className={clsx('', className)} {...props}>
      {children}
    </div>
  )
}
